import React from "react";
function AggregatorHostedwithPaymode() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content" class="mt-20 mb-20">
              <h2>Aggregator Hosted with Paymode</h2>
              <hr />
            </section>

            <p>
              The <b>Safexpay</b> payment integration provides the feature to show only specific selected paymodes on our Payment page. 

            </p>

            <div className="img-div">
              <img src="assets/images/Devdoc3.png" alt="logo" />
            </div>

            {/* Aggregator Hosted with Paymode flow dig: strat */}

            {/* Aggregator Hosted with Paymode flow dig. end */}

            <u>
              <h4>Process flow</h4>
            </u>

            <ul>
              <li>
                <p>
                  Merchant can configure the Semi-billing page by showing the
                  Cards / Net banking / Wallets/ UPI etc. pay modeson their
                  checkout page.
                </p>
              </li>
              <li>
                <p>
                  Customer selects the respective Paymode options like
                  Cards/CC/UPI etc. on Merchant's Checkout page.
                </p>
              </li>
              <li>
                <p>
                  Customer redirects to <b>Safexpay</b> Payment page with the
                  selected Paymode options, where customer can fill the relevant
                  detail.
                </p>
              </li>
              <li>
                <p>
                  On submission of the transaction information, <b>Safexpay</b>{" "}
                  initiates the authorization process by connecting to the
                  relevant bank/processing organization.
                </p>
              </li>
              <li>
                <p>
                  On receiving the authorization status from the bank,{" "}
                  <b>Safexpay</b> sends the response back to your website with
                  the transaction status.
                </p>
              </li>
            </ul>

            <section id="idocs_content" class="mt-20 mb-20">
              <h2>
                Safexpay Test Environments for Aggregator Hosted with Paymode
              </h2>
              <hr />
            </section>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr>
                  <td className="table-color">Post URL</td>
                  <td>
                    {/* <a href="https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage">
                      https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage
                    </a> */}
                    <span>https://uatcheckout.safexpay.ae/ms-transaction-core-1-0/paymentRedirection/checksumGatewayPage</span>
                  </td>
                </tr>
                <tr>
                  <td className="table-color">Merchant ID</td>
                  <td>202308230003</td>
                </tr>
                <tr>
                  <td className="table-color">Encryption Key</td>
                  <td>QfZUv2MKcIEWV3AhjpCLCpAsIVWCj4xtsZb9PxWWEHA</td>
                </tr>
                <tr>
                  <td className="table-color">Aggregator ID</td>
                  <td> paygate</td>
                </tr>
              </tbody>
            </table>

            <u>
              <h4>Request Parameters</h4>
            </u>

            <p>
              Merchant must send the following parameters to{" "}
              <b className="para-blod">Safexpay</b> PG for processing an order.
            </p>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>
                    Section: Txn_Details (Required Parameters)
                  </th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>ag_id</td>
                  <td>YES</td>
                  <td>Alphabets (11)</td>
                  <td>Aggregator id is “paygate”</td>
                </tr>

                <tr>
                  <td>me_id</td>
                  <td>YES</td>
                  <td> Numeric (20)</td>
                  <td>MerchantID issued to you by Safexpay.</td>
                </tr>

                <tr>
                  <td>order_no</td>
                  <td>YES</td>
                  <td>Alphanumeric (70)</td>
                  <td>
                    {" "}
                    This ID is used by merchants to identify the order. Ensure
                    that you send a <b>unique id</b> with each request. As it
                    generates a unique payment reference number for each order
                    which is sent by the merchant.
                  </td>
                </tr>

                <tr>
                  <td>Amount</td>
                  <td>YES</td>
                  <td> Numeric (20,2)</td>
                  <td>
                    This is your Transaction Amount. You can use up to 2 decimal
                    places. E.g., “150.00”
                  </td>
                </tr>

                <tr>
                  <td>Country</td>
                  <td>YES</td>
                  <td>Alphabets (3)</td>
                  <td>
                    Country code needs to be passed, Country code as “ARE” for
                    United Arab Emirates . “ITA” for Italy. “USA” for United
                    states of America. “GBR” for Great Britain.
                  </td>
                </tr>

                <tr>
                  <td>Currency</td>
                  <td>YES</td>
                  <td>Alphabets (3)</td>
                  <td>
                    Currency in which you want to process the transaction. AED -
                    Emirati Dirham USD - United States Dollar GBP - Pound
                    Sterling EUR - Euro
                  </td>
                </tr>

                <tr>
                  <td>txn_type</td>
                  <td>YES</td>
                  <td> Alphabets (10)</td>
                  <td>
                    Use Txn_Type as <b> “SALE” </b> which is static witheach
                    request
                  </td>
                </tr>

                <tr>
                  <td>success_url</td>
                  <td>YES</td>
                  <td>
                    Alphanumeric (200) <b>Characters allowed :</b> Alphabet
                    (A-Z), (a-z), Numbers, / (slash), _ (underscore)
                  </td>
                  <td>
                    This will be the return URL where response is accepted for
                    successful transaction.
                  </td>
                </tr>

                <tr>
                  <td>failure_url</td>
                  <td>YES</td>
                  <td>
                    Alphanumeric (200 <b>Characters allowed :</b> Alphabet
                    (A-Z), (a-z) Numbers, / (slash), _ (underscore)
                  </td>
                  <td>
                    This will be the return URL where response is accepted for
                    failed transaction.
                  </td>
                </tr>

                <tr>
                  <td>Channel</td>
                  <td>YES</td>
                  <td>Alphabet (10)</td>
                  <td>
                    Use <b>“WEB”</b> in case of website-based payment or{" "}
                    <b>“MOBILE”</b> in case of mobile app. Static value with
                    each request.
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: pg_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>pg_id</td>
                  <td>NO</td>
                  <td>Numeric (11)</td>
                  <td>
                    This is the Bank Identification code assigned by Safexpay
                    Team only{" "}
                    <b>if the Integration type is Merchant Hosted (SEAMLESS)</b>{" "}
                    otherwise the value must be blank in the request.
                  </td>
                </tr>

                <tr>
                  <td>Paymode</td>
                  <td>NO</td>
                  <td> Alphabets (2)</td>
                  <td>
                    This is the Paymode Identification code assigned by Safexpay
                    Team only
                    <b>
                      if the Integration type is Merchant Hosted (SEAMLESS)
                    </b>{" "}
                    otherwise the value must be blank in the request.
                  </td>
                </tr>

                <tr>
                  <td>Scheme</td>
                  <td>NO</td>
                  <td>Numeric (11)</td>
                  <td>
                    This is the Scheme Identification code assigned by Safexpay
                    Team only
                    <b>
                      if the Integration type is Merchant Hosted (SEAMLESS)
                    </b>{" "}
                    otherwise the value must be blank in the request.
                  </td>
                </tr>

                <tr>
                  <td>emi_months</td>
                  <td>NO</td>
                  <td> Numeric (11)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: card_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>card_no</td>
                  <td>NO</td>
                  <td>Numeric (19)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>

                <tr>
                  <td>exp_month</td>
                  <td>NO</td>
                  <td> Numeric (2)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>

                <tr>
                  <td>exp_year</td>
                  <td>NO</td>
                  <td>Numeric (4)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>

                <tr>
                  <td>cvv</td>
                  <td>NO</td>
                  <td> Numeric (3)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>

                <tr>
                  <td>card_name</td>
                  <td>NO</td>
                  <td> Alphabets (50)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: cust_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>cust_name</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer Name. This is required required for fraud
                    protection.
                  </td>
                </tr>

                <tr>
                  <td>
                    email_id <b>(Mandatory)</b>{" "}
                  </td>
                  <td>YES</td>
                  <td>
                    Alphanumeric (100) Characters allowed: Alphabet (A-Z),
                    (a-z). Numbers @ (at), dot, _ (underscore)
                  </td>
                  <td>
                    Customer's Email ID. This is required required for fraud 
                    protection.
                  </td>
                </tr>

                <tr>
                  <td>
                    mobile_no <b>(Mandatory)</b>
                  </td>
                  <td>YES</td>
                  <td>Numeric (15)</td>
                  <td>
                    Customer's Mobile Number. This is required required for fraud 
                    protection.
                  </td>
                </tr>

                <tr>
                  <td>unique_id</td>
                  <td>NO</td>
                  <td> Alphanumeric (100)</td>
                  <td>
                    This is required in case of <b>Stored card feature.</b>
                  </td>
                </tr>

                <tr>
                  <td>is_logged_in</td>
                  <td>YES</td>
                  <td> Alphabets (1)</td>
                  <td>Pass “Y” if user is logged in</td>
                </tr>
              </tbody>
            </table>

            {/* <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: card_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>
                <tr>
                  <td>card_no</td>
                  <td>NO</td>
                  <td>Numeric (19)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>

                <tr>
                  <td>exp_month</td>
                  <td>NO</td>
                  <td> Numeric (2)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>

                <tr>
                  <td>exp_year</td>
                  <td>NO</td>
                  <td>Numeric (4)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>

                <tr>
                  <td>cvv</td>
                  <td>NO</td>
                  <td> Numeric (3)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>

                <tr>
                  <td>card_name</td>
                  <td>NO</td>
                  <td> Alphabets (50)</td>
                  <td>
                    Value must be blank for Aggregator Hosted (Non-Seamless)
                  </td>
                </tr>
              </tbody>
            </table> */}

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: Bill_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>bill_addres</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (400) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular brackets,
                    /(slash), dot,- (hyphen) Space in between words{" "}
                  </td>
                  <td>
                    Customer's Billing Address. This is required required for
                    fraud protection.
                  </td>
                </tr>

                <tr>
                  <td>bill_city</td>
                  <td>Optional</td>
                  <td>Optional (50)</td>
                  <td>
                    Customer's Billing City. This is required required for fraud
                    protection.
                  </td>
                </tr>

                <tr>
                  <td>bill_state</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Billing State. This is required required for fraud
                    protection.
                  </td>
                </tr>
                <tr>
                  <td>bill_country</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Billing Country.This is required required for
                    fraud protection.
                  </td>
                </tr>

                <tr>
                  <td>bill_zip</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (20) <b>Characters allowed:</b> Alphabet
                    (A-Z),(a-z). Numbers
                  </td>
                  <td>
                    Customer's Billing Zip/Pin Code.This is required for fraud
                    protection.
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: Ship_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>ship_address</td>
                  <td>Optional</td>
                  <td>
                    Alphanumeric (400) <b> Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular brackets,
                    /(slash), dot,- (hyphen) Space in between words
                  </td>
                  <td>
                    Customer's Shipping Address. This is required in case of
                    physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_city</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Shipping City. This is required in case of
                    physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_state</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer's Shipping State. This is required in case of
                    physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_country</td>
                  <td>Optional</td>
                  <td>Alphabets (50)</td>
                  <td>
                    Customer’s Shipping Country. This is required in case of
                    physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>ship_zip</td>
                  <td>Optional</td>
                  <td>Alphanumeric (20)</td>
                  <td>
                    Customer's Shipping Zip/Pin Code. This is required in case
                    of physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                  <td>
                    <b>Characters allowed:</b> Alphabet (A-Z),(a-z). Numbers{" "}
                  </td>
                  <td></td>
                </tr>

                <tr>
                  <td>ship_days</td>
                  <td>Optional</td>
                  <td>Numeric (11)</td>
                  <td>
                    Approximate number of days required for delivery of goods.
                    This is required in case of physical delivery of goods.
                  </td>
                </tr>

                <tr>
                  <td>address_count</td>
                  <td>Optional</td>
                  <td>Numeric (11)</td>
                  <td>
                    If customer has more than one addresses stored in your
                    system.
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: Item_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>item_count</td>
                  <td>Optional</td>
                  <td>Alphanumeric (11)</td>
                  <td>Count of items purchased by customer.</td>
                </tr>

                <tr>
                  <td>item_value</td>
                  <td>Optional</td>
                  <td>Optional (200,2)</td>
                  <td>Comma separated item wise cost</td>
                </tr>

                <tr>
                  <td>item_category</td>
                  <td>Optional</td>
                  <td>Alphanumeric (200)</td>
                  <td>Comma separated item category. E.g., “DVD”</td>
                </tr>
              </tbody>
            </table>

            <table class="table table-bordered">
              <tbody className="table-bdy">
                <tr className="table-main-title">
                  <th colSpan={7}>Section: Other_details</th>
                </tr>
                <tr className="table-color">
                  <th>Parameter Name</th>
                  <th>Mandate</th>
                  <th> Type (length)</th>
                  <th>Description</th>
                </tr>

                <tr>
                  <td>udf_1</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_2</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_3</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_4</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>

                <tr>
                  <td>udf_5</td>
                  <td>Optional</td>
                  <td>
                    {" "}
                    Alphanumeric (100) <b>Characters allowed:</b> Alphabet
                    (A-Z), (a-z). Numbers # (hash), Comma, circular
                    brackets,/(slash), dot, -(hyphen) Space in between words
                  </td>
                  <td>
                    This parameter can be used for sending additional
                    information about the transaction. PG will send this
                    parameter in the response.
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="note-div">
              <b className="aggHost-note">Note :</b>

              <p>
              Value in each section will be encrypted value generated in the following way. Only me_id (Merchant ID) will be in plain text. 
              </p>

              <p>
              Each attribute in every section is combined and separated with pipe (|). Make sure that you are sending the request in the
                <b className="para-blod"> HTTP Form post method.</b>
              </p>

              <p>
                <b className="para-blod">Please find the format shared below:</b>
              </p>
              <p>
              The transaction request is not compatible with the {" "}
                <span className="highlighter-cusm">Postman Platform.</span>
              </p>

              <p>

              Transactions are only permitted through registered merchant domains. If “localhost” or local IP is not permitted, you will get an 
                <b className="para-blod">“Invalid Referral URL.” </b> error in
                such case.
              </p>

              <p>
              Transaction requests must be in the manner below when it trigger to our Payment Gateway URL. Merchants must send the following parameters to the <b>Safexpay</b> PG, which is mandatory, but values might be blank if they are optional or not required. 
              </p>

              <p className="para-underline">
              Example of the Transaction request in HTTP Form post method: Sample HTML transaction posting:
              </p>

              <ul>
                <li>

                Make sure that you are sending the request in the
                  <b className="para-blod"> HTTP Form post method.</b>
                </li>
                <li>
                  Transactions are only permitted through registered merchant
                  domains. If “localhost” or local IP is not permitted, you will
                  get <b className="para-blod">“Invalid Referral URL.” </b>{" "}
                  error.
                </li>
                <li>
                  {" "}
                  Transaction request must be in the manner below when it triggers to our Payment Gateway URL. 
                </li>
                <li>
                  {" "}
                  Merchants  must send the following parameters to the{" "}
                  <b className="para-blod">Safexpay</b> PG which is mandatory,
                  but values might be blank in case of optional or not required
                </li>
              </ul>

              <p className="para-underline">
              Please note only HTML Form Submission with the ‘POST’ method is supported. Sending payment requests using any REST API call is not supported.
              </p>
            </div>

            <div className="img-div">
              <img src="assets/images/Screenshot-code1.png" alt="logo" />
            </div>

            <div className="prgm-div">
              <p className="para-underline mt-2">
                Sample Request Before Encryption:
              </p>

              <p>
                {" "}
                <b className="para-blod">me_id :</b> 202308230003
              </p>
              <p>
                <b className="para-blod">merchant request :</b>{" "}
                paygate|202308230003|63010|16|ARE|AED|SALE|http://localhost/PHP_with_Checksum_1/t
ransaction//Response.php|http://localhost/PHP_with_Checksum_1/transaction//Response.ph
p|WEB~|CC||~||||~||||Y~||||~||||||~||~~||||
hash:aa6d5f750d806f3a74a99def53bfea4212e01294ffc4d643ccb79db842483033
              </p>
              <p>
                <b className="para-blod">Hash :</b>{" "}
                aa6d5f750d806f3a74a99def53bfea4212e01294ffc4d643ccb79db842483033
              </p>
            </div>

            <div className="prgm-div">
              <p className="para-underline mt-2">
                Sample Request After Encryption:
              </p>

              <p>
                <b className="para-blod">me_id :</b> 202308230003
              </p>
              <p>
                <b className="para-blod">merchant request :</b>{" "}
                tUlHLvNuLlPTReXpyx77h9d0GnQBfwCgStLuVNs2EtynGj+7LS4PUNfg5KkdDTmzdU1oGowmF2
Dl09xH9Zut66AW4M3Se+DuOtBd+lbM8zXzLJ1vfCDF+BcDc/rXT11zdeb/B0ZtPOUdYWoOq99BVn
oezL86/Z3sr2B+AJYuirFUO07eGtZ2GfiX3LLT6VyIQSbUWUkjptxDBHHL3jJf94G+LD5vtYm7daejZa
A4LsO6f7AVPcr0bMkZkpzq8FHcx3tzU/DaY0DOYhR2MpEPVXCxe2lL5e7q BwJ0yfBh/E=
              </p>
              <p>
                <b className="para-blod">Hash :</b>{" "}
                vUQyjw7oBv1CpIfUZMfDqKctYxisfdRuP+TT2lEewPQAxRwjeo2oPqp0fpU9zKSUOGUs+yX6Xc05lBk
GbGehZNXvT npafH4Of HnQaWZhU0s=
              </p>

              <p className="para-underline ">
                Merchant_request will get encrypt by aes256 (Details shared
                below) :
              </p>

              <p>
                {" "}
                <b>
                $all_values =
$txn_details.'~'.$pg_details.'~'.$card_details.'~'.$cust_details.'~'.$bill_details.'~'.$ship_details.
'~'.$item_details.'~'.$other_details;$merchant_request['merchant_request'] =
$aes-encrypt($all_values, $merchant_key, 256);
                </b>
              </p>
              <p className="para-underline ">Encrypted Response:</p>
              <p>
                <b className="para-blod">txn_response :</b>{" "}
                TtUlHLvNuLlPTReXpyx77qW/qtmL0ckXKQzuOyXNink2F1l3fySNprHsVljbpTLxPod7GyLRD176AdX
8FGBZBVTkXfKqN8VgbhRnFJZ9ac3kEjEuO7MHsIFxVt8RoepfOhukSUOx5jtDYaDRktoikPeRzhli7N
X4YZZr9lhoWmE7clRc+pR+pBwfvDQMSZiVgxmqGHHMVrFAcSq2oKc+dXe/968KbDpf4LEpUSRHp
I0RmH5oPo5c9X4HQpvsf3qlf5zf3VLIvwtgiRpHOdBcemoCasML0RCjd0NyVDUIohDCUyRihznlBZo
HgWgGQsbp

              </p>

              <p>
                <b className="para-blod">me_id: 202308230003</b>
              </p>

              <p>
                <b className="para-blod">pg_details : </b>
                VV0QKi7vnuAXxrQFAMVEmDhwlh+zOAkKF0ZjKMCELOU=
              </p>
              <p>
                <b className="para-blod">fraud_details : </b>
                LczLp4wIzTWyQYYpg4dyPg==
              </p>
              <p>
                <b className="para-blod">other_details : </b>
                ZMBVDYvFlbIjxcD19WxmLw==
              </p>

              <p className="para-underline ">Decrypted Response :</p>

              <p>
                <b className="para-blod">txn_response :</b> paygate|202308230003|63010|16.00|ARE|AED|2022-01-
05|12:40:01.0|1078624810853426146|PG_1078624810853426146|Successful~uv/MI7UYTFBM
pBPBzIjpkzd9iRv2RIDEO9+jZj1Wq1e01vZ9Pt8hNSPmTdCIbVtfciFxXcKotL7UYGem0OIioI9pLJ4GVw
hh6sIgXu0eq/U=~|0|Successful

              </p>

              <p>
                <b className="para-blod">me_id: 202308230003</b>
              </p>

              <p>
                <b className="para-blod">pg_details : </b> 629|Test Bank|CC|
              </p>
              <p>
                <b className="para-blod">fraud_details : </b> |NA|
              </p>
              <p>
                <b className="para-blod">other_details : </b> ||||NA|||||
              </p>
            </div>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
  );
}
export default AggregatorHostedwithPaymode;
